import React from "react";
import { Box } from "@mui/material";
import { useInput } from "react-admin";

const commonStyles = {
  hidden: {
    display: "none",
  },
};

export const HiddenInput = (props: any) => {
  const { source, value } = props;
  const { field } = useInput({ source, defaultValue: value });

  return (
    <Box sx={commonStyles.hidden}>
      <input {...field} type="hidden" readOnly />
    </Box>
  );
};
